export const MANUAL_SIGN_IN = 'Manual Sign In';
export const GOOGLE_SIGN_IN = 'Google Sign In';
export const SIGN_UP = 'sign_up';
export const BE_LOG_IN = 'be_log_in';
